import _extends from "@babel/runtime/helpers/extends";
import { ChevronDown } from "lucide-react";
import React from "react";
import Button from "../Button";
import DropdownMenu from "../DropdownMenu";
import { BaseComboButton } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ComboButton(_ref) {
  var size = _ref.size,
    mainButtonProps = _ref.mainButtonProps,
    items = _ref.items;
  return /*#__PURE__*/_jsxs(BaseComboButton, {
    size: size,
    children: [/*#__PURE__*/_jsx(Button, _extends({
      "data-vitality-component": "combo-button-main"
    }, mainButtonProps, {
      size: size
    })), /*#__PURE__*/_jsx(DropdownMenu, {
      preferredAlignment: "end",
      trigger: {
        type: "button",
        props: {
          size: size,
          "data-vitality-component": "combo-button-dropdown",
          iconLeft: /*#__PURE__*/_jsx(ChevronDown, {}),
          children: "",
          appearance: mainButtonProps === null || mainButtonProps === void 0 ? void 0 : mainButtonProps.appearance
        }
      },
      items: items
    })]
  });
}
export default ComboButton;